/**
 * Centralized query key factory for the AttachmentsStep.
 */
export const attachmentsKeys = {
    all: ['proposal-attachments'],
    list: (proposalId) => [...attachmentsKeys.all, 'list', proposalId],
    buildingPhotos: (proposalId) => [...attachmentsKeys.all, 'building-photos', proposalId],
    inspectionReports: (proposalId) => [...attachmentsKeys.all, 'inspection-reports', proposalId]
};
